
import React from 'react';
// import box from './box.svg';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from "@material-ui/core/styles";

// import check1 from './check_open_transparent_black.svg';
// import check2 from './checked.svg';
// import check3 from './checked_open.svg';
// import check4 from './checked_open_black.svg';
// import check5 from './check5.svg';
// import check6 from './check6.svg';
// import check7 from './check7.svg';
// import check8 from './check8.svg';

import './Task.css';
import moment from 'moment';

moment.updateLocale('en', {
    relativeTime : {
        future: "in %s",
        past:   "%s ago",
        s  : 'a few seconds',
        ss : '%d seconds',
        m:  "a minute",
        mm: "%d minutes",
        h:  "an hour",
        hh: "%d hours",
        d:  "a day",
        dd: "%d days",
        w:  "a week",
        ww: "%d weeks",
        M:  "a month",
        MM: "%d months",
        y:  "a year",
        yy: "%d years"
    }
});

const BlueCheckbox = withStyles({
  root: {
    color: "#03a9f4",
    "&$checked": {
      color: "#03a9f4"
    }
  },
  checked: {}
})((props) => <Checkbox color="default" {...props} />);

class Task extends React.Component {

	constructor(props) {
	    super(props);
  	}


	componentDidUpdate() {
	}

    toggleComplete() {
        this.props.toggleComplete();

        //this.setState({checked: !this.state.checked})
    }


	render() {
        var p = this.props.parentsTextArray;

		return 	<div className="TaskItem">
					
					<div className="TextItemCheckbox">
                        <BlueCheckbox
                            checked={this.props.obj.complete}
                            onChange={this.toggleComplete.bind(this)}
                            name="checkedF"
                          />
                    </div>
					
                    <div className="TaskItemText">{this.props.obj.t}

                    <div className="TaskItemParents">
                        {p.map((item, index) => <span key={item}> {item} {index === p.length-1 ? null : '>'}</span>)}
                    </div>

                    </div>

					<div className="TaskItemDue">{ moment(this.props.obj.due.toDate()).fromNow() }</div>



				</div>;
	}
}

export default Task;